<template>
  <div class="continer">
    <div class="center">
      <span>0475-6336566</span>
      <span>内蒙通辽欢迎您!</span>
    </div>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="stylus" scoped>
.continer
  width 100%
  height 45px
  background #000
  .center
    width 1200px
    display flex
    margin 0  auto
    line-height 45px
    flexword-wrap wrap
    justify-content space-between
    color #fff
    font-size 14px
</style>